export default __webpack_public_path__ + "static/media/34.08cc3d0d.gif";